import React from "react";
import {
  Box,
  CssBaseline,
  Grid,
  ThemeProvider,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import Common from "./Common";
import Ledgerhome from "../../../assets/Ledgerhome.png";
import Bitehome from "../../../assets/Bitehome.png";

const gridData = [
  {
    imgSrc: Ledgerhome,
    title: "Ledger",
    subtitle: "Revamp your cash management with our sleek register!",
    borderColor: `${theme.palette.primary.main}`,
    color: `${theme.palette.primary.main}`,
    link: "/ledger",
  },
  {
    imgSrc: Bitehome,
    title: "Bite",
    subtitle:
      "Simplify canteen operations with inventory and service efficiency!",
    borderColor: "#0C9D46",
    color: "#0C9D46",
    link: "/bite",
  },
];

const Others = () => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          marginTop: isSm ? "3.75rem" : "7.5rem",
          marginBottom: isSm ? "3.75rem" : "7.5rem",
          marginLeft: isSm ? "0.75rem" : "10.25rem",
          marginRight: isSm ? "0.75rem" : "10.25rem",
        }}
      >
        <Grid container spacing={isSm ? 5 : 13}>
          {gridData.map((item, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Common
                title={item.title}
                subtitle={item.subtitle}
                imgSrc={item.imgSrc}
                borderColor={item.borderColor}
                color={item.color}
                link={item.link}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default Others;